import { renderSlot as _renderSlot, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, mergeProps as _mergeProps, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue";
const _hoisted_1 = {
    key: 0,
    class: "scTable-page"
};
const _hoisted_2 = {
    class: "scTable-pagination"
};
const _hoisted_3 = {
    key: 0,
    class: "scTable-do"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_el_table_column = _resolveComponent("el-table-column");
    const _component_el_empty = _resolveComponent("el-empty");
    const _component_el_table = _resolveComponent("el-table");
    const _component_el_pagination = _resolveComponent("el-pagination");
    const _component_el_button = _resolveComponent("el-button");
    const _component_columnSetting = _resolveComponent("columnSetting");
    const _component_el_popover = _resolveComponent("el-popover");
    const _component_el_radio_button = _resolveComponent("el-radio-button");
    const _component_el_radio_group = _resolveComponent("el-radio-group");
    const _component_el_form_item = _resolveComponent("el-form-item");
    const _component_el_checkbox = _resolveComponent("el-checkbox");
    const _component_el_form = _resolveComponent("el-form");
    const _directive_loading = _resolveDirective("loading");
    return _withDirectives((_openBlock(), _createElementBlock("div", {
        class: "scTable",
        style: _normalizeStyle({
            'height': $options._height
        }),
        ref: "scTableMain"
    }, [
        _createElementVNode("div", {
            class: "scTable-table",
            style: _normalizeStyle({
                'height': $options._table_height
            })
        }, [
            (_openBlock(), _createBlock(_component_el_table, _mergeProps(_ctx.$attrs, {
                data: $data.tableData,
                "row-key": $props.rowKey,
                key: $data.toggleIndex,
                ref: "scTable",
                height: $props.height == 'auto' ? null : '100%',
                size: $data.config.size,
                border: $data.config.border,
                stripe: $data.config.stripe,
                "summary-method": $props.remoteSummary ? $options.remoteSummaryMethod : $props.summaryMethod,
                onSortChange: $options.sortChange,
                onFilterChange: $options.filterChange
            }), {
                empty: _withCtx(()=>[
                        _createVNode(_component_el_empty, {
                            description: $data.emptyText,
                            "image-size": 100
                        }, null, 8, [
                            "description"
                        ])
                    ]),
                default: _withCtx(()=>[
                        _renderSlot(_ctx.$slots, "default", {}, undefined, true),
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.userColumn, (item, index)=>{
                            return _openBlock(), _createElementBlock(_Fragment, {
                                key: index
                            }, [
                                !item.hide ? (_openBlock(), _createBlock(_component_el_table_column, {
                                    key: 0,
                                    "column-key": item.prop,
                                    label: item.label,
                                    prop: item.prop,
                                    width: item.width,
                                    sortable: item.sortable,
                                    fixed: item.fixed,
                                    filters: item.filters,
                                    "filter-method": $props.remoteFilter || !item.filters ? null : $options.filterHandler,
                                    "show-overflow-tooltip": item.showOverflowTooltip
                                }, {
                                    default: _withCtx((scope)=>[
                                            _renderSlot(_ctx.$slots, item.prop, _mergeProps({
                                                ref_for: true
                                            }, scope), ()=>[
                                                    _createTextVNode(_toDisplayString(scope.row[item.prop]), 1)
                                                ], true)
                                        ]),
                                    _: 2
                                }, 1032, [
                                    "column-key",
                                    "label",
                                    "prop",
                                    "width",
                                    "sortable",
                                    "fixed",
                                    "filters",
                                    "filter-method",
                                    "show-overflow-tooltip"
                                ])) : _createCommentVNode("", true)
                            ], 64);
                        }), 128)),
                        $props.showFlex ? (_openBlock(), _createBlock(_component_el_table_column, {
                            key: 0,
                            "min-width": "1"
                        })) : _createCommentVNode("", true)
                    ]),
                _: 3
            }, 16, [
                "data",
                "row-key",
                "height",
                "size",
                "border",
                "stripe",
                "summary-method",
                "onSortChange",
                "onFilterChange"
            ]))
        ], 4),
        !$props.hidePagination || !$props.hideDo ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
                !$props.hidePagination ? (_openBlock(), _createBlock(_component_el_pagination, {
                    key: 0,
                    background: "",
                    size: "small",
                    layout: $props.paginationLayout,
                    total: $data.total,
                    "page-size": $data.scPageSize,
                    "page-sizes": $props.pageSizes,
                    currentPage: $data.currentPage,
                    "onUpdate:currentPage": _cache[0] || (_cache[0] = ($event)=>$data.currentPage = $event),
                    onCurrentChange: $options.paginationChange,
                    "onUpdate:pageSize": $options.pageSizeChange
                }, null, 8, [
                    "layout",
                    "total",
                    "page-size",
                    "page-sizes",
                    "currentPage",
                    "onCurrentChange",
                    "onUpdate:pageSize"
                ])) : _createCommentVNode("", true)
            ]),
            !$props.hideDo ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                !$props.hideRefresh ? (_openBlock(), _createBlock(_component_el_button, {
                    key: 0,
                    onClick: $options.refresh,
                    icon: "el-icon-refresh",
                    circle: "",
                    style: {
                        "margin-left": "15px"
                    }
                }, null, 8, [
                    "onClick"
                ])) : _createCommentVNode("", true),
                $props.column ? (_openBlock(), _createBlock(_component_el_popover, {
                    key: 1,
                    placement: "top",
                    title: "列设置",
                    width: 500,
                    trigger: "click",
                    "hide-after": 0,
                    onShow: _cache[1] || (_cache[1] = ($event)=>$data.customColumnShow = true),
                    onAfterLeave: _cache[2] || (_cache[2] = ($event)=>$data.customColumnShow = false)
                }, {
                    reference: _withCtx(()=>[
                            _createVNode(_component_el_button, {
                                icon: "el-icon-set-up",
                                circle: "",
                                style: {
                                    "margin-left": "15px"
                                }
                            })
                        ]),
                    default: _withCtx(()=>[
                            $data.customColumnShow ? (_openBlock(), _createBlock(_component_columnSetting, {
                                key: 0,
                                ref: "columnSetting",
                                onUserChange: $options.columnSettingChange,
                                onSave: $options.columnSettingSave,
                                onBack: $options.columnSettingBack,
                                column: $data.userColumn
                            }, null, 8, [
                                "onUserChange",
                                "onSave",
                                "onBack",
                                "column"
                            ])) : _createCommentVNode("", true)
                        ]),
                    _: 1
                })) : _createCommentVNode("", true),
                !$props.hideSetting ? (_openBlock(), _createBlock(_component_el_popover, {
                    key: 2,
                    placement: "top",
                    title: "表格设置",
                    width: 400,
                    trigger: "click",
                    "hide-after": 0
                }, {
                    reference: _withCtx(()=>[
                            _createVNode(_component_el_button, {
                                icon: "el-icon-setting",
                                circle: "",
                                style: {
                                    "margin-left": "15px"
                                }
                            })
                        ]),
                    default: _withCtx(()=>[
                            _createVNode(_component_el_form, {
                                "label-width": "80px",
                                "label-position": "left"
                            }, {
                                default: _withCtx(()=>[
                                        _createVNode(_component_el_form_item, {
                                            label: "表格尺寸"
                                        }, {
                                            default: _withCtx(()=>[
                                                    _createVNode(_component_el_radio_group, {
                                                        modelValue: $data.config.size,
                                                        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event)=>$data.config.size = $event),
                                                        size: "small",
                                                        onChange: $options.configSizeChange
                                                    }, {
                                                        default: _withCtx(()=>[
                                                                _createVNode(_component_el_radio_button, {
                                                                    value: "large"
                                                                }, {
                                                                    default: _withCtx(()=>[
                                                                            ..._cache[6] || (_cache[6] = [
                                                                                _createTextVNode("大", -1)
                                                                            ])
                                                                        ]),
                                                                    _: 1
                                                                }),
                                                                _createVNode(_component_el_radio_button, {
                                                                    value: "default"
                                                                }, {
                                                                    default: _withCtx(()=>[
                                                                            ..._cache[7] || (_cache[7] = [
                                                                                _createTextVNode("正常", -1)
                                                                            ])
                                                                        ]),
                                                                    _: 1
                                                                }),
                                                                _createVNode(_component_el_radio_button, {
                                                                    value: "small"
                                                                }, {
                                                                    default: _withCtx(()=>[
                                                                            ..._cache[8] || (_cache[8] = [
                                                                                _createTextVNode("小", -1)
                                                                            ])
                                                                        ]),
                                                                    _: 1
                                                                })
                                                            ]),
                                                        _: 1
                                                    }, 8, [
                                                        "modelValue",
                                                        "onChange"
                                                    ])
                                                ]),
                                            _: 1
                                        }),
                                        _createVNode(_component_el_form_item, {
                                            label: "样式"
                                        }, {
                                            default: _withCtx(()=>[
                                                    _createVNode(_component_el_checkbox, {
                                                        modelValue: $data.config.border,
                                                        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event)=>$data.config.border = $event),
                                                        label: "纵向边框"
                                                    }, null, 8, [
                                                        "modelValue"
                                                    ]),
                                                    _createVNode(_component_el_checkbox, {
                                                        modelValue: $data.config.stripe,
                                                        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event)=>$data.config.stripe = $event),
                                                        label: "斑马纹"
                                                    }, null, 8, [
                                                        "modelValue"
                                                    ])
                                                ]),
                                            _: 1
                                        })
                                    ]),
                                _: 1
                            })
                        ]),
                    _: 1
                })) : _createCommentVNode("", true)
            ])) : _createCommentVNode("", true)
        ])) : _createCommentVNode("", true)
    ], 4)), [
        [
            _directive_loading,
            $data.loading
        ]
    ]);
}
